// src/settingComponent/apiSetting/ApiInvoice.jsx
import React from 'react';
import './ApiInvoice.css';

const ApiInvoice = ({ invoices, onClose }) => {
  // Get the current date and the date 12 months ago
  const currentDate = new Date();
  const twelveMonthsAgo = new Date(currentDate.setMonth(currentDate.getMonth() - 12));

  // Filter the invoices to only show those created in the last 12 months
  const filteredInvoices = invoices.filter(inv => {
    const invoiceDate = new Date(inv.invoiceCreated.seconds * 1000);
    return invoiceDate >= twelveMonthsAgo;
  });

  return (
    <div className="api-invoice-overlay">
      <div className="api-invoice-modal">
        <div className="api-invoice-header">
          <h2>Billing history</h2>
          <button className="api-invoice-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="api-invoice-body">
          {filteredInvoices.length > 0 ? (
            <>
              <p className="invoice-subtitle">Showing invoices within the past 12 months</p>
              <div className="invoice-table-container">
                <table className="invoice-table">
                  <thead>
                    <tr>
                      <th>Invoice</th>
                      <th>Status</th>
                      <th>Amount</th>
                      <th>Created</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredInvoices.map(inv => (
                      <tr key={inv.id}>
                        <td>{inv.invoiceNumber}</td>
                        <td>
                          <span className="invoice-status">{inv.invoiceStatus}</span>
                        </td>
                        <td>{`$${(inv.invoiceAmountCents / 100).toFixed(2)}`}</td>
                        <td>{new Date(inv.invoiceCreated.seconds * 1000).toLocaleString()}</td>
                        <td>
                          <a href={inv.invoiceUrl} target="_blank" rel="noopener noreferrer">
                            <button className="invoice-view-button">View</button>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="no-invoices-container">
              No invoices available from the past 12 months.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApiInvoice;
